const STAGE_API_URL = "https://stageapi.itweb.co.za/";
const STAGE_API_TIMEOUT_MS = 5000;

export async function checkStageApiAvailability() {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), STAGE_API_TIMEOUT_MS);

  try {
    await fetch(STAGE_API_URL, {
      method: "HEAD",
      signal: controller.signal,
      mode: "no-cors",
    });

    return true;
  } catch (error) {
    console.warn("Stage API not available:", error.message);
    return false;
  } finally {
    clearTimeout(timeoutId);
  }
}